import { motion } from "framer-motion";
import { memo } from "react";
import { ChevronDown } from "lucide-react";

const WA_LINK = "https://wa.me/393296281756?text=Ciao%20Danielealoisi%2C%20vorrei%20un%20preventivo%2Fsopralluogo%20per%20infissi%20o%20lavorazioni%20in%20ferro.%20Zona%3A%20_____%20.%20Posso%20inviare%20alcune%20foto.";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-background">
      {/* Video background with fade-in */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        className="absolute inset-0 w-full h-full object-cover"
        src="/videos/hero-bg.mp4"
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-background/85" />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="relative z-10 text-center px-6"
      >
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight text-foreground"
        >
          Infissi e ferro su misura<br />a Roma e Guidonia
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-6 text-sm md:text-base tracking-wide text-foreground font-semibold font-body max-w-xl mx-auto"
        >
          Puntualità, attenzione ai dettagli e casa pulita a fine lavoro, con smaltimento rifiuti incluso. Ti seguiamo fino alla consegna e anche dopo.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a href="#contact" className="cta-button hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300">
            Richiedi preventivo
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 text-sm tracking-widest uppercase font-body bg-[#25D366] text-white rounded-sm hover:-translate-y-0.5 active:scale-[0.98] transition-all duration-300"
          >
            Scrivi su WhatsApp
          </a>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.8 }}
        className="absolute bottom-10 flex flex-col items-center gap-3"
      >
        <span className="scroll-indicator">Scorri</span>
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ duration: 2, repeat: Infinity }}>
          <ChevronDown size={20} className="text-muted-foreground" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default memo(HeroSection);